import {Injectable} from '@angular/core';
import {MedicalProblemDataService} from './medicalProblemData.service';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {MedicalRecordProblemModel} from '../../../api/model/medicalRecordProblem.model';
import {MedicalRecordProblemConverter} from '../../../api/converter/medicalRecordProblem.converter';

@Injectable({providedIn: 'root'})
export class MedicalProblemDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<MedicalRecordProblemModel, MedicalRecordProblemConverter> {
    constructor(dataService: MedicalProblemDataService, converter: MedicalRecordProblemConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): MedicalRecordProblemModel {
        return new MedicalRecordProblemModel();
    }
}
